const marketing = {
    name: 'marketing',
    state: {
        returnUrl: '',
        template: {
            customTemplateId: '',
            textReplace: [],
            imageReplace: []
        }
    },
    reducers: {
        setUrl: ( state, payload ) => {
            return { 
                ...state,
                returnUrl: payload
            }
        },
        setTid: ( state, payload ) => {
            return { 
                ...state,
                template: {
                    ...state,
                    customTemplateId: payload
                }
            }
        },
        setTextReplace: ( state, payload ) => {
            return { 
                ...state,
                template: {
                    ...state.template,
                    textReplace: payload
                }
            }
        },
        setImageReplace: ( state, payload ) => {
            return { 
                ...state,
                template: {
                    ...state.template,
                    imageReplace: payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        setTemplate( { url, tid, tr, ir } ) {
            dispatch.marketing.setUrl( url );
            dispatch.marketing.setTid( tid );
            if ( tr ) {
                dispatch.marketing.setTextReplace( tr );
            }
            if ( ir ) {
                dispatch.marketing.setImageReplace( ir );
            }
        }
    } )
}

export default marketing;




// 63521e8993d0f07a59450a90